import { z } from 'zod';

/**
 * The review page's URL search: `?mode=review` opens it in Review mode
 * (GEN-3261), so a reviewer can be sent a link straight into it. Anything
 * else opens the grid. `?thread=<id>` opens a comment thread on its cell
 * (GEN-3329, where a mention notification lands), then leaves the URL.
 */
export const ReviewPageSearchSchema = z.object({
  mode: z.enum(['review']).optional().catch(undefined),
  thread: z.uuid().optional().catch(undefined),
});
export type ReviewPageSearch = z.infer<typeof ReviewPageSearchSchema>;

export function isReviewMode(search: ReviewPageSearch): boolean {
  return search.mode === 'review';
}

/** `search` with Review mode turned on or off; off drops the key. */
export function withReviewMode(
  search: ReviewPageSearch,
  on: boolean,
): ReviewPageSearch {
  return { ...search, mode: on ? 'review' : undefined };
}
